import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import './style/variables.scss';
import lazyPlugin from 'vue3-lazy';
import print from 'vue3-print-nb';
import App from './App.vue';
import router from './router';
import store from './store';

const renderApp = () => {
  const app = createApp(App);
  app.use(ElementPlus);
  app.use(print);
  app.use(lazyPlugin, {
    loading: '',
    error: '',
  });
  app.use(store).use(router).mount('#app');
};

renderApp();

const resizeFunc = () => {
  let rem = 100;
  if (document.documentElement.clientWidth <= 600) {
    rem = (document.documentElement.clientWidth / 360) * 100;
    store.commit('SET_ISMOBILE', true);
  } else {
    store.commit('SET_ISMOBILE', false);
  }
  document.getElementsByTagName('html')[0].style['font-size'] = rem + 'px';
};
resizeFunc();
window.addEventListener('resize', resizeFunc, false);
